/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import CorporationContainer from './corporation/container/CorporationContainer';
import IndividualContainer from './individual/container/IndividualContainer';
import TransactionsContainer from './transactions/TransactionsContainer';
import CdlSettingsContainer from './settings/CdlSettingsContainer';

function CDLContainer({ match, permissions, }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">Cedula Transactions</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/cedula"
        >
          Dashboard
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/cedula/individual"
        >
          Individual
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/cedula/corporation"
        >
          Corporation
        </NavLink>
        {Acl(permissions, ['VIEW CEDULA SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/cedula/settings"
          >
            Settings
          </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route
          path={`${match.path}/individual`}
          component={IndividualContainer}
        />
        <Route
          path={`${match.path}/corporation`}
          component={CorporationContainer}
        />
        {Acl(permissions, ['VIEW CEDULA SETTINGS']) && (
          <Route
            path={`${match.path}/settings`}
            component={CdlSettingsContainer}
          />
        )}
      </Switch>
    </div>
  );
}

CDLContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => {
  return {
    permissions: getJson('permissions'),
  };
};
const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps),
]);

export default enhance(CDLContainer);
